// Using a placeholder image - you can replace this with your actual review image
import reviewImage from '../assets/images/Reviews/WhatsApp Image 2025-11-05 at 9.41.46 PM.jpeg';

export const useReviews = () => {
  const reviews = [
    {
      id: 1,
      name: "Priya Sharma",
      title: "Wedding Decorations",
      rating: 5,
      review: "Absolutely stunning decorations for my wedding! The team was professional and delivered beyond our expectations. Every detail was perfect.",
      image: reviewImage,
      date: "2024-01-15"
    },
    {
      id: 2,
      name: "Rajesh Kumar",
      title: "Birthday Party Setup",
      rating: 5,
      review: "Amazing birthday party decorations! The kids loved it and the setup was exactly what we wanted. Highly recommended!",
      image: reviewImage,
      date: "2024-01-10"
    },
    {
      id: 3,
      name: "Anita Singh",
      title: "Anniversary Celebration",
      rating: 4,
      review: "Beautiful anniversary decorations that made our special day even more memorable. Great service and attention to detail.",
      image: reviewImage,
      date: "2024-01-08"
    },
    {
      id: 4,
      name: "Vikram Patel",
      title: "Corporate Event",
      rating: 5,
      review: "Professional service for our corporate event. The decorations were elegant and perfectly suited for the occasion.",
      image: reviewImage,
      date: "2024-01-05"
    },
    {
      id: 5,
      name: "Sunita Reddy",
      title: "Baby Shower",
      rating: 5,
      review: "Lovely baby shower decorations! The team understood our vision and brought it to life beautifully. Thank you!",
      image: reviewImage,
      date: "2024-01-03"
    },
    {
      id: 6,
      name: "Amit Gupta",
      title: "Festival Decorations",
      rating: 4,
      review: "Great festival decorations for Diwali! The traditional elements were beautifully incorporated. Very satisfied with the service.",
      image: reviewImage,
      date: "2024-01-01"
    }
  ];

  return { reviews };
};
